import 'intersection-observer'

// TODO: Replace all body-scroll-locks to scroll-lock and then remove the first from the list
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueScrollActive from 'vue-scrollactive'
import TailwindCssSelectors from '@/components/TailwindCssSelectors.vue'

import '@/app.css'

// Components
import parallaxScroll from '@/components/ParallaxScoll'
import buttonRipple from '@/components/ButtonRipple'
import heroSlider from '@/components/HeroSlider'
import fadeInText from '@/components/FadeInAnimation'
import GtmTracking from '@/components/GtmTracking'
import CampaignTracking from '@/components/CampaignTracking'
import accordion from '@/components/Accordion'
import chatbot from '@/components/ChatBot'

import AdimoButton from '@/components/AdimoButton.vue'
import Picture from '@/components/Picture.vue'
import MainMenu from '@/components/MainMenu.vue'
import Slider from '@/components/Slider.vue'
import VideoOverlayTrigger from '@/components/VideoOverlayTrigger.vue'
import VideoOverlay from '@/components/VideoOverlay.vue'
import MediaBlock from '@/components/MediaBlock.vue'
import CookieBanner from '@/components/CookieBanner.vue'
import YoutubeVideo from '@/components/YoutubeVideo.vue'
import Video from '@/components/Video.vue'

import RecipeIngredients from '@/components/recipes/RecipeIngredients.vue'
import RecipeNavBar from '@/components/recipes/NavigationBar.vue'

import SubNavigation from '@/components/SubNavigation.vue'

import ProductsOverview from '@/components/products/ProductsOverview.vue'
import FacetComponents from '@/components/facet'
import vueUtil from '@/vue-utils'

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(VueScrollActive)

const components = {
  AdimoButton,
  Picture,
  MainMenu,
  Slider,
  VideoOverlayTrigger,
  VideoOverlay,
  MediaBlock,
  CookieBanner,
  RecipeIngredients,
  RecipeNavBar,
  ProductsOverview,
  YoutubeVideo,
  ...FacetComponents,
  Video,
  TailwindCssSelectors,
  SubNavigation
}

vueUtil.mountComponents(components)

// Init scripts
buttonRipple()
parallaxScroll()
heroSlider()
fadeInText('.animated-item')
GtmTracking()
CampaignTracking()
accordion('.c-faq-opener')
chatbot()
